export const DEFAULT_DATAVERSE_HOST = "kodikas-dev.crm4";
export const DATAVERSE_URL_PREFIX = "https://";
export const DATAVERSE_URL_SUFFIX = ".dynamics.com/api/data/v9.0/";

export function normalizeDataverseHostSegment(input: string): string {
  return input
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//i, "")
    .replace(/\.dynamics\.com.*$/i, "")
    .replace(/\/$/, "");
}

export function getDataverseApiBaseUrlFromHostSegment(hostSegment: string): string {
  const normalizedHost = normalizeDataverseHostSegment(hostSegment);
  if (!normalizedHost) {
    throw new Error("Dataverse host segment is required.");
  }

  return `${DATAVERSE_URL_PREFIX}${normalizedHost}${DATAVERSE_URL_SUFFIX}`;
}

export function getDataverseDelegatedScopeFromHostSegment(hostSegment: string): string {
  const parsed = new URL(getDataverseApiBaseUrlFromHostSegment(hostSegment));
  return `${parsed.origin}/user_impersonation`;
}
